'use client';

import { useEffect } from 'react';
import Link from 'next/link';

/** Galat tak tertangani di halaman panel; `reset()` mencoba merender ulang. */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <section className="p-6">
      <p className="font-mono text-[12px] tracking-[0.18em] text-charcoal/55">Galat</p>
      <h1 className="mt-2 font-display text-[clamp(1.7rem,2.4vw,2.3rem)] leading-none text-charcoal">
        Halaman gagal dimuat
      </h1>
      <p className="mt-1.5 max-w-[52ch] text-[13px] text-charcoal/75">
        Coba muat ulang halaman ini. Kalau berulang, catat kodenya dan sampaikan ke tim teknis.
      </p>
      <div className="mt-5 flex flex-wrap gap-1.5">
        <button
          type="button"
          onClick={reset}
          className="rounded-md bg-lime px-4 py-2 text-[13px] font-bold text-charcoal"
        >
          Coba lagi
        </button>
        <Link
          href="/"
          className="rounded-md bg-white px-4 py-2 text-[13px] font-bold text-charcoal"
        >
          Ke ringkasan
        </Link>
      </div>
      {error.digest ? (
        <p className="mt-3 font-mono text-[11px] text-charcoal/55">Kode: {error.digest}</p>
      ) : null}
    </section>
  );
}
